var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "create-service-level"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "text": "Please Wait. It may take a while for large number of records",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Service Level Template")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Service Level List"
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    attrs: {
      "style": "font-size:18px;cursor:pointer"
    }
  })])])])])]), _vm._v(" "), _c('b-card', [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Service Level Template Name")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.seriveLevelTemplateName),
      expression: "seriveLevelTemplateName"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('TemplateName')
    },
    attrs: {
      "type": "text",
      "name": "TemplateName",
      "id": "TemplateName",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.seriveLevelTemplateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.seriveLevelTemplateName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('TemplateName')),
      expression: "errors.has('TemplateName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter service level template name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Service Level Template Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serviceLevelTemplateDescription),
      expression: "serviceLevelTemplateDescription"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Description",
      "id": "Description",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.serviceLevelTemplateDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serviceLevelTemplateDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Route Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Surface",
      "value": "Surface",
      "name": "RouteMode"
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Surface")
    },
    on: {
      "change": _vm.ClearForm,
      "__c": function($event) {
        _vm.RouteMode = "Surface"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Surface"
    }
  }, [_vm._v("Surface ")]), _vm._v("     \n                  "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Air",
      "value": "Air",
      "name": "RouteMode"
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Air")
    },
    on: {
      "change": _vm.ClearForm,
      "__c": function($event) {
        _vm.RouteMode = "Air"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Air"
    }
  }, [_vm._v("Air")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RouteMode')),
      expression: "errors.has('RouteMode')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Route Mode field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servicetype),
      expression: "servicetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Service Type",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.servicetype, "1")
    },
    on: {
      "change": _vm.ClearForm,
      "__c": function($event) {
        _vm.servicetype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("City to City    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servicetype),
      expression: "servicetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Service Type",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.servicetype, "2")
    },
    on: {
      "change": _vm.ClearForm,
      "__c": function($event) {
        _vm.servicetype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Zone to Zone")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Service Type')),
      expression: "errors.has('Service Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select serivce type.")])])], 1)]), _vm._v(" "), (_vm.servicetype == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Ops TAT master"
    },
    on: {
      "click": function($event) {
        _vm.downloadOpsTATMaster()
      }
    }
  }, [_vm._v("Download Ops TAT master")])])]) : _vm._e(), _vm._v(" "), (_vm.servicetype == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download pin code master"
    },
    on: {
      "click": function($event) {
        _vm.downloadPincodeMaster()
      }
    }
  }, [_vm._v("Download pin code master")])]), _vm._v(" "), (_vm.showSalesTatDownload) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Sales TAT"
    },
    on: {
      "click": function($event) {
        _vm.downloadSalesTAT()
      }
    }
  }, [_vm._v("Download Sales TAT (City to City)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.servicetype == 2) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSalesTatDownload) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Sales TAT"
    },
    on: {
      "click": function($event) {
        _vm.downloadSalesTATZoneToZone()
      }
    }
  }, [_vm._v("Download Sales TAT (Zone To Zone) ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.servicetype == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Upload Sales TAT(City to City)")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    },
    attrs: {
      "for": "FileUpload"
    }
  }, [_c('a', {
    staticClass: "-btn btn-info"
  }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "files",
    attrs: {
      "id": "FileUpload",
      "name": "FileUpload",
      "accept": ".csv",
      "type": "file",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.resetFile()
      },
      "change": _vm.chooseFile
    }
  }), _vm._v("  \n                  "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.filename) + "\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.FileUpload')),
      expression: "errors.has('uploadform.FileUpload')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Choose file to upload")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.filename != null && _vm.servicetype == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Validate File"
    },
    on: {
      "click": function($event) {
        _vm.validateFile()
      }
    }
  }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.isupload == 1 && _vm.invaliddatacount > 0 && _vm.servicetype == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Invalid records details:")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Download (CSV)"
    },
    on: {
      "click": function($event) {
        _vm.downloadInvalidData()
      }
    }
  }, [_vm._v("Download (CSV)")])])]) : _vm._e(), _vm._v(" "), (_vm.invaliddatacount > 0 && _vm.isupload == 1 && _vm.servicetype == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "offset": _vm.offset
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.servicetype == 2) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download 18 x 18 template"
    },
    on: {
      "click": function($event) {
        _vm.download18x18Template()
      }
    }
  }, [_vm._v("Download 18 x 18 template")])])]) : _vm._e(), _vm._v(" "), (_vm.servicetype == 2) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Upload Sales TAT(18x18)")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    },
    attrs: {
      "for": "FileUpload"
    }
  }, [_c('a', {
    staticClass: "-btn btn-info"
  }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "files",
    attrs: {
      "id": "FileUpload",
      "name": "FileUpload",
      "accept": ".csv",
      "type": "file",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.resetFile()
      },
      "change": _vm.choose18x18File
    }
  }), _vm._v("  \n                  "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.filename) + "\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.FileUpload')),
      expression: "errors.has('uploadform.FileUpload')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Choose file to upload")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.filename != null && _vm.servicetype == 2) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Validate File"
    },
    on: {
      "click": function($event) {
        _vm.validate18x18File()
      }
    }
  }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.isupload == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.isupload == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validdatacount))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.invaliddatacount))])])]), _vm._v(" "), (_vm.validdatacount == _vm.totalrecords && _vm.isupload == 1 && _vm.validdatacount != 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Submit"
    },
    on: {
      "click": function($event) {
        _vm.confirmServiceLevelDataUpdate()
      }
    }
  }, [_vm._v("Submit")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.invalid18x18Data.length > 0 && _vm.servicetype == 2) ? _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Invalid Records")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("Origin Zone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("Destination Zone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("TAT ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("Error Message ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.invalid18x18Data), function(data, index) {
    return (_vm.invalid18x18Data.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.originzone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationzone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TAT))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.msg))])]) : _vm._e()
  }), _vm._v(" "), (_vm.invalid18x18Data.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e()]), _vm._v(" "), _c('br')])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3e96caa","hasScoped":true}!./src/modules/masterdata/views/ServiceLevelTemplate/CreateServiceLevel/CreateServiceLevel.component.html
// module id = 811
// module chunks = 3